/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolNatureIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-nature"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.7 20.2L10.7 16.55L8.95 16.55Q6.58 16.55 4.91 14.89Q3.25 13.22 3.25 10.85Q3.25 9.2 4.08 7.79Q4.9 6.38 6.4 5.75Q6.67 3.67 8.28 2.36Q9.88 1.05 12 1.05Q14.13 1.05 15.72 2.36Q17.32 3.67 17.6 5.75Q19.1 6.4 19.93 7.8Q20.75 9.2 20.75 10.85Q20.75 13.22 19.09 14.89Q17.43 16.55 15.05 16.55L13.35 16.55L13.35 20.2L18.43 20.2Q18.98 20.2 19.36 20.59Q19.75 20.98 19.75 21.52Q19.75 22.07 19.36 22.46Q18.98 22.85 18.43 22.85L5.58 22.85Q5.03 22.85 4.64 22.46Q4.25 22.07 4.25 21.52Q4.25 20.98 4.64 20.59Q5.03 20.2 5.58 20.2Z" fill={color} />
    </svg>
  );
}
